import {
  FaqDto,
  FaqLabelVM,
  FaqListResponse,
  FaqPayloadVM,
} from "../types/faq.definition";
import {
  requestCreateFaq,
  requestDeleteFaq,
  requestGetFaqById,
  requestGetFaqChildren,
  requestGetFaqs,
  requestUpdateFaq,
} from "../webclients/faq.client";

export const faqApi = {
  getFaqs: async (
    lang: string = "fr",
    page: number = 0,
    size: number = 10
  ): Promise<FaqListResponse> => {
    const response = await requestGetFaqs(lang, page, size);
    const totalCount = parseInt(response.headers?.["x-total-count"] ?? "0", 10);
    return { data: response.data as FaqDto[], totalCount };
  },

  createFaq: async (data: FaqPayloadVM): Promise<FaqPayloadVM> => {
    const response = await requestCreateFaq(data);
    return response.data;
  },

  updateFaq: async (id: number, data: FaqPayloadVM): Promise<FaqPayloadVM> => {
    const response = await requestUpdateFaq(id, data);
    return response.data;
  },

  deleteFaq: async (id: number): Promise<void> => {
    await requestDeleteFaq(id);
  },

  getFaqAllTranslations: async (id: number): Promise<FaqLabelVM> => {
    const [enRes, frRes, arRes] = await Promise.all([
      requestGetFaqById(id, "en"),
      requestGetFaqById(id, "fr"),
      requestGetFaqById(id, "ar"),
    ]);
    return {
      en: {
        title: (enRes.data as FaqDto).title ?? "",
        description: (enRes.data as FaqDto).description ?? "",
      },
      fr: {
        title: (frRes.data as FaqDto).title ?? "",
        description: (frRes.data as FaqDto).description ?? "",
      },
      ar: {
        title: (arRes.data as FaqDto).title ?? "",
        description: (arRes.data as FaqDto).description ?? "",
      },
    };
  },

  getFaqChildren: async (
    parentId: number,
    lang: string = "fr"
  ): Promise<FaqDto[]> => {
    const response = await requestGetFaqChildren(parentId, lang);
    return response.data as FaqDto[];
  },
};
